import React from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { principles } from '../../../data/site';
import { EASE_OUT } from '../../../lib/motion';
import SectionIntro from '../../primitives/SectionIntro';
import TraceRule from '../../primitives/TraceRule';

// Fast. Scalable. Secure. — each principle as a full-width typographic row
const Principles = ({ index = '03' }) => {
  const reduced = useReducedMotion();
  return (
    <section className="section">
      <div className="container-site">
        <SectionIntro index={index} label="Why us" title="Why choose *us*">
          We deliver excellence through innovation and dedication
        </SectionIntro>

        <div className="mt-[clamp(3rem,6vw,5rem)]">
          {principles.map((item, i) => (
            <div key={item.title} className="group">
              <TraceRule jog={0.08 + i * 0.26} delay={i * 0.1} />
              <div className="grid gap-4 py-8 md:grid-cols-12 md:items-center md:py-12">
                <span className="label md:col-span-2">({String(i + 1).padStart(2, '0')})</span>
                <motion.h3
                  className="display-lg md:col-span-5"
                  initial={reduced ? false : { opacity: 0, x: -24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.6 }}
                  transition={{ duration: 1, ease: EASE_OUT, delay: 0.1 }}
                >
                  <span className="inline-block transition-transform duration-700 ease-out-expo group-hover:translate-x-3">
                    {item.title}
                    <span className="text-brand">.</span>
                  </span>
                </motion.h3>
                <motion.p
                  className="lede md:col-span-5"
                  initial={reduced ? false : { opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.6 }}
                  transition={{ duration: 1, ease: EASE_OUT, delay: 0.2 }}
                >
                  {item.description}
                </motion.p>
              </div>
            </div>
          ))}
          <TraceRule jog={0.86} />
        </div>
      </div>
    </section>
  );
};

export default Principles;
